import React from 'react';
import { Link } from 'react-router-dom';
import './Security.css';

const securityFeatures = [
  { icon: '🔐', title: 'AES‑256 Encryption', desc: 'All data at rest and in transit is protected with military‑grade AES‑256 encryption.' },
  { icon: '🔑', title: 'Multi‑Signature Protection', desc: 'Multiple signatures are required for any asset movement, eliminating single points of failure.' },
  { icon: '❄️', title: 'Cold Storage Integration', desc: 'The majority of assets are held in offline cold wallets, completely isolated from the internet.' },
  { icon: '🛡️', title: '24/7 Threat Monitoring', desc: 'Our security operations centre monitors for threats around the clock, every day of the year.' },
  { icon: '🧬', title: 'Biometric Access', desc: 'Access to sensitive operations can require biometric verification for an extra layer of security.' },
  { icon: '📋', title: 'Complete Audit Trails', desc: 'Every action is logged and traceable, providing full transparency and accountability.' },
];

const commitments = [
  { title: 'Bank‑Level Security', desc: 'We employ the same security protocols used by leading financial institutions.' },
  { title: 'Multi‑Layer Protection', desc: 'Multiple, overlapping security layers ensure no single vulnerability can compromise assets.' },
  { title: 'Cold Storage', desc: 'Private keys are kept offline and geographically distributed for maximum safety.' },
  { title: 'Encrypted & Private', desc: 'All user data is encrypted end‑to‑end and handled with strict privacy policies.' },
  { title: '24/7 Monitoring', desc: 'Security experts monitor our infrastructure continuously, ready to respond to any anomaly.' },
  { title: 'Regular Audits', desc: 'We conduct regular penetration tests and security audits by independent third parties.' },
];

function Security() {
  return (
    <div className="security-page">

      {/* ── Back to Home arrow ── */}
      <Link
        to="/"
        style={{
          position: 'fixed',
          top: '1.25rem',
          left: '1.25rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.4rem',
          color: 'rgba(255,255,255,0.75)',
          fontSize: '0.9rem',
          fontWeight: 500,
          zIndex: 100,
          transition: 'color 0.2s',
          textDecoration: 'none',
        }}
        onMouseEnter={e => e.currentTarget.style.color = '#fff'}
        onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.75)'}
      >
        ← Home
      </Link>

      <div className="security-hero">
        <h1>Military‑Grade Security</h1>
        <p>Your assets are protected by the most advanced security infrastructure available.</p>
      </div>

      <section className="features-section">
        <h2>Core Security Features</h2>
        <div className="features-grid">
          {securityFeatures.map((feat, idx) => (
            <div key={idx} className="feature-card">
              <span className="feature-icon">{feat.icon}</span>
              <div>
                <h3>{feat.title}</h3>
                <p>{feat.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="commitments-section">
        <h2>Our Security Commitment</h2>
        <div className="commitment-grid">
          {commitments.map((c, idx) => (
            <div key={idx} className="commitment-card">
              <h3>{c.title}</h3>
              <p>{c.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <div className="security-footer">
        <p className="security-tagline">YOUR ASSETS ARE SAFE WITH US</p>
        <p>Recovery Vault is built with security, transparency and trust at its core.</p>
      </div>
    </div>
  );
}

export default Security;